function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.4998 13.8959C13.6987 13.8959 12.9303 13.5776 12.3638 13.0111C11.7973 12.4446 11.479 11.6762 11.479 10.875C11.479 10.0738 11.7973 9.30548 12.3638 8.73897C12.9303 8.17245 13.6987 7.85419 14.4998 7.85419C15.301 7.85419 16.0694 8.17245 16.6359 8.73897C17.2024 9.30548 17.5207 10.0738 17.5207 10.875C17.5207 11.2717 17.4425 11.6645 17.2907 12.031C17.1389 12.3975 16.9164 12.7306 16.6359 13.0111C16.3554 13.2916 16.0224 13.5141 15.6559 13.6659C15.2894 13.8177 14.8965 13.8959 14.4998 13.8959V13.8959ZM14.4998 2.41669C12.2565 2.41669 10.1051 3.30783 8.51889 4.89408C6.93265 6.48032 6.0415 8.63173 6.0415 10.875C6.0415 17.2188 14.4998 26.5834 14.4998 26.5834C14.4998 26.5834 22.9582 17.2188 22.9582 10.875C22.9582 8.63173 22.067 6.48032 20.4808 4.89408C18.8945 3.30783 16.7431 2.41669 14.4998 2.41669V2.41669Z",
  fill: "white"
});

var SvgMapIcon = function SvgMapIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMapIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mapIcon.bae5b87b.svg";
export { ForwardRef as ReactComponent };